/**
 * Editor id is the Vue filename stem. FlowTouchpointEditor overrides the ChannelType convention.
 * @param {{ ChannelType?: string, FlowTouchpointEditor?: string }} channel
 */
export function resolveTouchpointEditorId(channel) {
    const override = channel?.FlowTouchpointEditor;
    if (typeof override === 'string' && override.trim())
        return override.trim();
    const ct = (channel?.ChannelType && String(channel.ChannelType).trim()) || 'Call';
    return `${ct}TouchpointEditor`;
}

/**
 * @param {Record<string, () => Promise<unknown>>} modules import.meta.glob result
 */
export function buildTouchpointEditorRegistry(modules) {
    const registry = {};
    const source = modules && typeof modules === 'object' ? modules : {};
    for (const path of Object.keys(source)) {
        const normalized = String(path).replace(/\\/g, '/');
        if (normalized.includes('/components/'))
            continue;
        const fileName = normalized.split('/').pop() || '';
        if (!fileName.endsWith('.vue'))
            continue;
        const id = fileName.slice(0, -'.vue'.length);
        if (!id)
            continue;
        registry[id] = source[path];
    }
    return registry;
}
